export const menuItems = [
  {
    active: true,
    item: {
      icon: "streamline:nature-ecology-rice-field-sun-rise-set-field-crop-produce-farm",
      title: "Wellspring",
      href: "/wellspring",
      titleClass: "text-emerald-400",
      image: {
        src: "https://ik.imagekit.io/8qxqs9cznn/general/SCR-20250220-iysl.png",
        title: "Wellspring",
        description: "Join the global marketplace where nature professionals pay for value-proven expertise.",
      }
    },
    subMenuItems: [
      {
        title: "Our marketplace",
        href: "/wellspring",
        description: "Join the global marketplace for nature professionals",
      },
      {
        title: "Chat",
        href: "/chat",
        description: "Get AI assistance for your nature professional needs",
      },
    ],
  },
  {
    active: false,
    item: {
      icon: "lucide:message-circle",
      title: "Chat",
      href: "/chat",
      titleClass: "text-purple-500",
      image: {
        src: "https://ik.imagekit.io/8qxqs9cznn/general/chat-interface.png",
        title: "AI Chat Assistant",
        description: "Get instant AI assistance for your nature professional needs and questions.",
      }
    },
    subMenuItems: [
      {
        title: "AI Assistant",
        href: "/chat",
        description: "Chat with our AI for expert guidance and support",
      },
      {
        title: "Chat History",
        href: "/chat/history",
        description: "View and manage your previous conversations",
      },
    ],
  },
  {
    active: true,
    item: {
      icon: "ant-design:aliwangwang-outlined",
      title: "Workspace",
      href: "/design",
      titleClass: "text-blue-800",  
      image: {
        src: "https://ik.imagekit.io/8qxqs9cznn/general/4640991169_0a27fd502e_k.jpg",
        title: "SuperSeeded Workspace",
        description: "The future of planting and procurement for landscape architects, contractors and growers..",
      }
    },

    subMenuItems: [
      {
        title: "Our planting design tool",
        href: "/planting",
        description: `High performance planting with instant availability, maintenance, biodiversity and geospatial mapping`
      },
    ],
  },
  {
    active: true,
    item: {
      icon: "lucide:truck",
      title: "Suppliers",
      href: "/supplier",
      titleClass: "text-pink-400",
      image: {
        src: "https://ik.imagekit.io/8qxqs9cznn/general/suppliers-network.png",
        title: "Supplier Network",
        description: "Connect with trusted suppliers and manage your procurement network.",
      }
    },
    subMenuItems: [
      {
        title: "Find Suppliers",
        href: "/supplier",
        description: "Browse and connect with verified suppliers in your area",
      },
      {
        title: "Supplier Directory",
        href: "/supplier/directory",
        description: "View comprehensive supplier listings and profiles",
      },
    ],
  }
];